import { useDispatch, useSelector } from "react-redux";
import "./steps.css";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import { AppDispatch, RootState } from "../../../redux/store";
import { useEffect, useState } from "react";
import {
  getSessionMessageV2,
  getSessionRestart,
  getSessionVerify,
  getSessionVerifyPn,
} from "../../../redux/actions/fluxoNSimilar";
import { Pagination } from "../../Pagination/pagination";
import Log from "../../logOfQuestions/log";
import {
  resetHttpStatus,
  resetMessage,
} from "../../../redux/slices/sessionMenssageSlice";
import IconEdit from "../../../assets/img/editar_input.png";
import Modal from "../../modal/modal";
import UploadImage from "../../fluxo-engenheiro/uploadImage/uploadImage";
import FormBasicInputImage from "../formBasic/formBasicInputImage";
import { Skeleton, Tooltip } from "@mui/material";
import { MessageComponent } from "../../MessageComponent/messageComponent";

interface QuestionsProps {
  infos: any;
  timeStamp: any;
  setDisplayTableAtributes: any;
  setGetSessionId: any;
  sessionQuestions: any;
  getLastQuestions: any;
  pnSimilarSelect: any;
}

const Questions = ({
  infos,
  timeStamp,
  setDisplayTableAtributes,
  setGetSessionId,
  pnSimilarSelect,
}: QuestionsProps) => {
  const [displayLoading, setDisplayLoading] = useState(true);
  const [questionsLog, setQuestionsLog] = useState<
    {
      pergunta: number;
      label: string;
      message: string;
    }[]
  >([]);
  const [modalDispplay, setModalDisplay] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [count, setCount] = useState(0);
  const [displayQuestions, setDisplayQuestions] = useState(false);
  const { sessionInfo } = useSelector((state: RootState) => state.sessionInfo);
  const { sessionMessage } = useSelector(
    (state: RootState) => state.sessionMessage,
  );

  const [getMessageQuestion, setGetMessageQuestion] = useState("");
  const [value, setValue] = useState("");
  const [initialQuestion, setInitialQuestion] = useState("first");
  const [, setLoadingDisplay] = useState(false);
  const [isSubmittingRefactoring, setIsSubmittingRefactoring] = useState(false);

  const dispatch = useDispatch<AppDispatch>();

  const [currentPage, setCurrentPage] = useState(0);

  const questionsPerPage = 3;
  const startIndex = currentPage * questionsPerPage;

  const paginatedQuestions = questionsLog.slice(
    startIndex,
    startIndex + questionsPerPage,
  );

  const wait = useSelector((state: RootState) => state.sessionInfo.status);

  useEffect(() => {
    setGetMessageQuestion(sessionMessage?.message?.shortMessage);
    setDisplayLoading(false);
  }, [sessionMessage]);

  useEffect(() => {
    setGetSessionId(sessionInfo?.message?.sessionId);

    setGetMessageQuestion(sessionInfo?.message?.shortMessage);

    if (sessionInfo?.message?.sessionMessageAnswer) {
      setValue(sessionInfo?.message?.sessionMessageAnswer);
    }
  }, [sessionInfo, sessionInfo?.message?.sessionMessageAnswer]);

  useEffect(() => {
    wait === "ready"
      ? setTimeout(() => {
          setDisplayLoading(false);
        }, 1000)
      : setDisplayLoading(true);
  }, [wait]);

  useEffect(() => {
    if (sessionMessage?.message?.finalized === true) {
      setDisplayTableAtributes(true);
    }
  }, [sessionMessage?.message]);

  const questionsFinalized = () => {
    if (sessionMessage?.message?.finalized === true) {
      setDisplayTableAtributes(true);
    } else {
      setCount((prevCount) => {
        const newCount = prevCount + 1;

        setQuestionsLog((prev) => [
          ...prev,
          {
            pergunta: newCount,
            label:
              getMessageQuestion !== undefined
                ? getMessageQuestion
                : infos?.shortMessage,
            message: value,
          },
        ]);

        return newCount;
      });

      questionsDispatchFinalized();
    }
  };

  const questionsDispatchFinalized = async (retryCount = 0) => {
    try {
      const formData = new FormData();

      // adiciona imagens
      selectedFiles.forEach((file) => {
        formData.append("files", file);
      });

      // adiciona payload JSON
      const dataPayload = {
        sessionId: sessionInfo.message.sessionId,
        shortMessage: retryCount === 1 ? "" : value,
        fromUser: true,
        finalized: sessionInfo.message.finalized,
        createdAt: timeStamp,
        sessionMessageQuestion: sessionMessage?.message.id
          ? sessionMessage?.message.id
          : sessionInfo?.message.id,
      };

      formData.append("data", JSON.stringify(dataPayload));

      const response = await dispatch(getSessionMessageV2(formData)).unwrap();

      setDisplayQuestions(true);
      setSelectedFiles([]);

      if (response.message.sessionMessageAnswer) {
        setValue(response.message.sessionMessageAnswer);
      } else {
        setValue("");
      }
    } catch (error: any) {
      if (error.httpStatus === 504 && retryCount < 2) {
        setDisplayLoading(true);
        setTimeout(() => questionsDispatchFinalized(retryCount + 1), 3000);
      } else if (retryCount === 1) {
        dispatch(getSessionVerify());
        dispatch(resetHttpStatus());
      }
    }
  };

  const goToPreviousQuestion = () => {
    if (count > 0) {
      setCount((prevCount) => prevCount - 1);
      setQuestionsLog((prevLog) => prevLog.slice(0, -1));
    }
  };

  const handleCloseModal = () => {
    setModalDisplay(false);
  };

  const handleConfirmModal = async () => {
    setQuestionsLog([]);
    setIsSubmittingRefactoring(true);
    dispatch(resetMessage());
    await dispatch(getSessionRestart(sessionInfo.message.sessionId));
    setValue("");
    setDisplayLoading(false);
    setGetMessageQuestion(sessionInfo?.message?.shortMessage);
    setDisplayQuestions(false);
    setCount(0);
    setInitialQuestion("first");
    setIsSubmittingRefactoring(false);
    setModalDisplay(false);
  };

  const startProfilledFlow = async () => {
    try {
      const response = await dispatch(
        getSessionVerifyPn(pnSimilarSelect.id),
      ).unwrap();

      if (response?.message?.sessionMenssageSlice) {
        setValue(response.message.sessionMessageAnswer);
      }

      setGetSessionId(response.message.sessionId);

      setGetMessageQuestion(response.message.shortMessage);

      setDisplayLoading(false);
    } catch (error) {
      console.error(
        "Erro ao iniciar o fluxo com dados pré-preenchidos:",
        error,
      );
    }
  };

  useEffect(() => {
    if (pnSimilarSelect?.id) {
      startProfilledFlow();
    }
  }, []);

  return (
    <div className="containerQuestions">
      <div className="containerQuestion">
        {displayLoading && (
          <>
            <div style={{ marginTop: 20 }}>
              <Skeleton variant="rectangular" width={310} height={30} />
              <br />
              <Skeleton variant="rectangular" width={580} height={80} />
              <br />
              <Skeleton variant="rectangular" width={378} height={105} />
              <br />
              <Skeleton variant="rectangular" width={104} height={50} />
              <br />
            </div>
          </>
        )}

        {displayLoading === false && (
          <>
            <FormBasicInputImage
              title=""
              label={
                <MessageComponent
                  message={
                    getMessageQuestion !== undefined
                      ? getMessageQuestion
                      : sessionInfo?.message?.shortMessage
                  }
                />
              }
              icon={IconEdit}
              setValue={setValue}
              value={value}
              displayEdit={
                !!value &&
                value.trim() !== "" &&
                !!sessionInfo.message.sessionMessageAnswer &&
                sessionInfo.message.sessionMessageAnswer.trim() !== ""
              }
              pnSimilarSelect={pnSimilarSelect}
              setSelectedFiles={setSelectedFiles}
              selectedFiles={selectedFiles}
              focusTrigger={
                sessionMessage?.message?.id ?? sessionInfo?.message?.id ?? ""
              }
            />

            <div style={{ width: 390, marginTop: 10 }}>
              <span>
                Para fazer o upload, arraste e solte os arquivos no campo de
                resposta ou clique em "Escolher arquivos".
              </span>
            </div>

            <div style={{ marginTop: "25px" }}>
              <UploadImage
                onFilesSelected={setSelectedFiles}
                setSelectedFiles={setSelectedFiles}
                selectedFiles={selectedFiles}
              />
            </div>
          </>
        )}
        <div className="container-button">
          {displayLoading === false && (
            <div className="button" style={{ display: "flex" }}>
              <ButtonGeneric
                title="Confirmar"
                colorTitle="#FFFFFF"
                background=""
                style="buttonGeneric buttonHover"
                onClick={() => {
                  setDisplayLoading(true);
                  setLoadingDisplay(true);
                  questionsFinalized();
                  setInitialQuestion("second");
                }}
                disabled={!value.trim()}
              />
            </div>
          )}

          <div className="button">
            <Tooltip title="Voltar ao início do questionário">
              <div>
                <ButtonGeneric
                  title="Refazer"
                  colorTitle="#007BC0"
                  background=""
                  style="buttonCustom"
                  onClick={() => {
                    setModalDisplay(true);
                  }}
                />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      {displayQuestions && (
        <>
          <div className="responseQuestions">
            <div>
              <h2>Perguntas respondidas sobre o material</h2>
              <>
                {paginatedQuestions.map((item) => (
                  <Log
                    key={item?.label}
                    pergunta={item?.pergunta}
                    label={item?.label}
                    message={item?.message}
                    onClick={goToPreviousQuestion}
                  />
                ))}

                {questionsLog.length > 3 && (
                  <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    questionsPerPage={questionsPerPage}
                    questionsLog={questionsLog}
                  />
                )}
              </>
            </div>
          </div>
        </>
      )}

      {modalDispplay && (
        <Modal
          titleModal="Aviso"
          className="buttonEditModal"
          titleDescription="Você deseja refazer a classificação?"
          bodyModal={
            <span style={{ marginTop: "-10px" }}>
              Você será redirecionado para a 1ª pergunta utilizada para
              classificação e precisará refazer todo o processo do zero.
            </span>
          }
          onClose={() => handleCloseModal()}
          onConfirm={() => handleConfirmModal()}
          buttonOne={isSubmittingRefactoring ? "Aguarde..." : "Sim"}
          buttonTwo="Não"
          isSubmitting={isSubmittingRefactoring}
        />
      )}
    </div>
  );
};

export default Questions;
